var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"mt-12"},[_c('v-col',{attrs:{"cols":"3"}}),_c('v-col',{staticClass:"text-center",attrs:{"cols":"6"}},[_c('div',{staticClass:"text-h1 grey--text"},[_vm._v(" 404, Oops ")]),_c('h1',{staticClass:"mt-6"},[_vm._v(" "+_vm._s(_vm.$route.params.message ?? "There was an error")+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }